// Regex patterns and error messages for validating HTML input fields
// Note: patterns that include accents must use the 'v' flag for Unicode property escapes
export const InputValidators = {
    basic: {
        pattern: "^[\\w]*$",
        errorMessage: "Please use letters, numbers, and _"
    },
    basicParen: {
        pattern: "^[\\w\\-\\(\\) ]*$",
        errorMessage: "Please use letters, numbers, spaces, and ( ) _ -"
    },
    latinParen: { 
        pattern: "^[\\p{Script=Latin}0-9_\\-\\(\\) ]*$", // requires 'v' flag
        errorMessage: "Please use letters (including Latin characters), numbers, spaces, and ( ) _ -"
    },
    latinComma: { 
        pattern: "^[\\p{Script=Latin}0-9_\\-\\, ]*$", // requires 'v' flag
        errorMessage: "Please use letters (including Latin characters), numbers, spaces, and , _ -"
    }
};